import { Component, Renderer2 } from '@angular/core';
import { GameHostComponent } from '../game-host/game-host.component';
import { SocketService } from '../shared/services/socket.service';
import { CookieService } from 'ngx-cookie-service';
import { Router, ActivatedRoute } from '@angular/router';
import { Message } from '../shared/model/message';
import { MessageType } from '../shared/model/message-type';
import { GameStatus } from '../shared/model/game-status';
import { SpinnerService } from '../shared/services/spinner.service';
import { WindowsService } from '../shared/services/windows.service';

@Component({
  selector: 'pbg-page-telestrations-host',
  templateUrl: './page-telestrations-host.component.html',
  styleUrls: ['./page-telestrations-host.component.scss']
})
export class PageTelestrationsHostComponent extends GameHostComponent {
  gameResults: any[] = [];
  gamePrefix = 'P';

  constructor(
    socketService: SocketService,
    cookieService: CookieService,
    router: Router,
    resolver: ActivatedRoute,
    renderer: Renderer2,
    spinnerService: SpinnerService,
    windowService: WindowsService
  ) {
    super(
      socketService,
      cookieService,
      router,
      resolver,
      renderer,
      spinnerService,
      windowService
    );
  }

  hostMessageHandler(message: Message) {
    if (message.action === MessageType.Host) {
      this.connectedUsers = (<any>Object).values(message.content.users);
      this.avatarWidth = `calc(${Math.floor(100 / this.connectedUsers.length)}% - 20px)`;
      if (message.content.status === GameStatus.Waiting) {
        this.gameId = message.content.id;
        this.cookieService.set('gameId', this.gameId, 1, '/');
      } else if (message.content.status === GameStatus.Complete) {
        const rounds = message.content.rounds;
        this.gameResults = [];

        for (const username in rounds) {
          if (rounds[username]) {
            for (let i = 1; i < rounds[username].length; i++) {
              const round = {
                name: username,
                originalWord: rounds[username][0].answer,
                artist: rounds[username][i].artist,
                isDrawing: rounds[username][i].type === 'draw',
                content: rounds[username][i].answer
              };

              this.gameResults.push(round);
            }
          }
        }
      }
    }
  }
}
